var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("new-edit-page", {
    staticStyle: { width: "100%" },
    attrs: {
      "is-loading": _vm.loading,
      "page-title": _vm.pageTitle,
      "submit-button-label": _vm.submitButtonLabel,
      "submit-button-disabled": _vm.submitButtonDisabled
    },
    on: { submit: _vm.saveObject },
    scopedSlots: _vm._u([
      {
        key: "leftSideContent",
        fn: function() {
          return [
            _c("form", { staticClass: "management-form" }, [
              _vm.type === "comment"
                ? _c("div", { staticClass: "input-field-container large" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v(_vm._s(_vm.$t("Description")))
                    ]),
                    _vm._v(" "),
                    _vm.comment
                      ? _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.comment.text,
                              expression: "comment.text"
                            }
                          ],
                          staticClass: "input-field",
                          attrs: { id: "description", required: "" },
                          domProps: { value: _vm.comment.text },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.comment, "text", $event.target.value)
                            }
                          }
                        })
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "ticket"
                ? _c("div", { staticClass: "input-field-container large" }, [
                    _c(
                      "label",
                      { staticClass: "required", attrs: { for: "summary" } },
                      [_vm._v(_vm._s(_vm.$t("Title")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.ticket.summary,
                          expression: "ticket.summary"
                        }
                      ],
                      staticClass: "input-field",
                      attrs: { type: "text", id: "summary", required: "" },
                      domProps: { value: _vm.ticket.summary },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.ticket, "summary", $event.target.value)
                        }
                      }
                    })
                  ])
                : _vm._e()
            ])
          ]
        },
        proxy: true
      },
      {
        key: "rightSideHeader",
        fn: function() {
          return [
            _c("management-tabs-and-search", {
              staticStyle: { float: "left" },
              attrs: {
                tabs: _vm.tabs,
                "open-tab": _vm.type === "ticket" ? _vm.openTab : "attachments"
              },
              on: {
                "update-open-tab": function($event) {
                  if (_vm.type === "ticket") {
                    _vm.openTab = $event
                  }
                }
              }
            }),
            _vm._v(" "),
            _vm.showAttachmentsButton
              ? _c(
                  "v-layout",
                  { attrs: { row: "", "justify-end": "" } },
                  [
                    _c(
                      "v-btn",
                      {
                        staticClass: "ma-0",
                        attrs: { icon: "", text: "", color: "accent" },
                        on: { click: _vm.openAttachmentForm }
                      },
                      [_c("v-icon", [_vm._v("add_circle")])],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "rightSideContent",
        fn: function() {
          return [
            _c(
              "v-tabs-items",
              {
                attrs: {
                  value: _vm.type === "ticket" ? _vm.openTab : "attachments"
                }
              },
              [
                _vm.type === "ticket"
                  ? _c(
                      "v-tab-item",
                      {
                        staticClass: "elevation-2",
                        attrs: { value: "description" }
                      },
                      [
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.ticket.description,
                              expression: "ticket.description"
                            }
                          ],
                          staticClass: "input-field",
                          staticStyle: { border: "none", height: "382px" },
                          attrs: { required: "", id: "description" },
                          domProps: { value: _vm.ticket.description },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.ticket,
                                "description",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  {
                    staticClass: "elevation-2",
                    attrs: { value: "attachments" }
                  },
                  [
                    _c("attachments-table", {
                      attrs: { attachments: _vm.attachmentToShow },
                      on: {
                        "open-attachment": _vm.openAttachment,
                        "remove-attachment": function($event) {
                          return _vm.removeAttachment($event)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("attachment-form", {
              attrs: { open: _vm.attachmentFormIsOpen },
              on: {
                "add-attachment": function($event) {
                  return _vm.saveAttachmentLocally($event)
                },
                close: _vm.closeAttachmentForm
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-132f2d47", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132f2d47","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/TechnicalSupport/SupportObjectCreateEdit.vue
// module id = null
// module chunks = 